import React, { PureComponent } from 'react'

import { WebhookTypesArray } from '../../utils/constants'

import ShopWebHookList from './ShopWebHookList'

const memoize = (func) => {
  let cache = null
  let key = null

  return (argument) => {
    if (key === argument) {
      return cache
    }

    key = argument
    return (cache = func(argument))
  }
}

class WebHooksList extends PureComponent {
  filteredWebHooks = memoize((lastModified) => {
    const { webHooks, shops } = this.props

    let filteredWebHooks = {}

    shops.forEach((shop) => {
      let webHookPlaceholder = {}

      WebhookTypesArray.forEach(
        (webHookItem) =>
          (webHookPlaceholder[webHookItem.value] = {
            shopId: shop.id,
            url: '',
            webHookType: webHookItem.value,
            webHookUrls: [],
          }),
      )

      filteredWebHooks[shop.id] = webHookPlaceholder
    })

    webHooks.forEach((webHook) => {
      filteredWebHooks[webHook.shopId] = filteredWebHooks[webHook.shopId] || {}
      filteredWebHooks[webHook.shopId][webHook.webHookType] = webHook
    })

    return filteredWebHooks
  })

  render() {
    const { shops, lastModified, onSave } = this.props

    const filteredWebHooks = this.filteredWebHooks(lastModified)
    return shops.map((shop) => (
      <ShopWebHookList
        key={shop.id}
        shop={shop}
        webHooks={filteredWebHooks[shop.id]}
        onSave={onSave}
        lastModified={lastModified}
      />
    ))
  }
}

export default WebHooksList



// WEBPACK FOOTER //
// ./src/components/WebHooks/WebHooksList.js